import { render, staticRenderFns } from "./PelleBarPanel.vue?vue&type=template&id=320a9096&scoped=true"
import script from "./PelleBarPanel.vue?vue&type=script&lang=js"
export * from "./PelleBarPanel.vue?vue&type=script&lang=js"
import style0 from "./PelleBarPanel.vue?vue&type=style&index=0&id=320a9096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320a9096",
  null
  
)

export default component.exports